import React from 'react';
import { Route, Switch } from 'react-router-dom';
import classNames from 'classnames';
import ErrorBoundary from '../../ErrorBoundary';
import { useStore } from '../../../store/rootStore';
import { observer } from 'mobx-react';
import ChatWindow from '../../Chat/ChatWindow';
import { Notifications } from '../../Notifications';
import ManagersRoute from '../../../routes/ManagersRoute';
import styles from './CenterContent.module.scss';
const CenterContent = () => {
    const { activeChatStore } = useStore();
    const isChatOpen = !!activeChatStore.chat;
    return (React.createElement("div", { className: classNames(styles.centerContent, {
            [styles.chatOpen]: isChatOpen,
        }) },
        React.createElement(ErrorBoundary, null,
            React.createElement(Switch, null,
                React.createElement(Route, { path: "/notifications", component: Notifications }),
                React.createElement(Route, { path: "/manage", component: ManagersRoute }),
                React.createElement(Route, { path: "/", component: ChatWindow })))));
};
export default observer(CenterContent);
